const wordpressBlocks = (): void => {
  const selectors = {
    wpVideoWrapper: '.wp-block-video',
    video: 'video',
  };

  const classes = {
    wpVideoWrapperPlaying: 'wp-block-video--playing',
    wpVideoWrapperPaused: 'wp-block-video--paused',
  };

  const videoWrappers = document.querySelectorAll(selectors.wpVideoWrapper);

  if (videoWrappers) {
    videoWrappers.forEach((videoWrapper) => {
      const video = videoWrapper.querySelector<HTMLVideoElement>(
        selectors.video
      );

      if (video) {
        // If not set to autoplay
        if (video.paused) {
          video.removeAttribute('controls');
          videoWrapper.classList.add(classes.wpVideoWrapperPaused);

          videoWrapper.addEventListener('click', () => {
            if (
              videoWrapper.classList.contains(classes.wpVideoWrapperPlaying)
            ) {
              setTimeout(() => {
                video.pause();
              }, 100);
            } else {
              setTimeout(() => {
                video.play();
              }, 100);
            }
          });
        }

        video.addEventListener('play', () => {
          video.setAttribute('controls', '');
          videoWrapper.classList.add(classes.wpVideoWrapperPlaying);
          videoWrapper.classList.remove(classes.wpVideoWrapperPaused);
        });

        video.addEventListener('pause', () => {
          video.removeAttribute('controls');
          videoWrapper.classList.remove(classes.wpVideoWrapperPlaying);
          videoWrapper.classList.add(classes.wpVideoWrapperPaused);
        });
      }
    });
  }
};

export default wordpressBlocks;
